export const LOGIN_MESSAGES = {
  success: "Successfully logged in!",
  invalid: "Invalid credentials. Please try again.",
};

export const FORM_VALIDATION_MESSAGES = {
  FIRST_NAME_REQUIRED: "First name is required.",
  LAST_NAME_REQUIRED: "Last name is required.",
  EMAIL_REQUIRED: "Email is required.",
  INVALID_EMAIL: "Invalid email address.",
  PASSWORD_REQUIRED: "Password is required.",
  PASSWORD_MIN_LENGTH: "Password must be at least 6 characters.",
  PHONE_NUMBER_REQUIRED: "Phone number is required.",
  INVALID_PHONE_NUMBER: "Phone number must be 10 digits.",
};
